import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFlipToFrontComponent } from "./med-icon-flip-to-front.component";

@NgModule({
  declarations: [
    MedIconFlipToFrontComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFlipToFrontComponent,
  ],
})
export class MedIconFlipToFrontModule { }
